import { render, staticRenderFns } from "./CustomerStoryLink.vue?vue&type=template&id=4f7865f0"
import script from "./CustomerStoryLink.vue?vue&type=script&lang=js"
export * from "./CustomerStoryLink.vue?vue&type=script&lang=js"
import style0 from "./CustomerStoryLink.vue?vue&type=style&index=0&id=4f7865f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports